<div class="summary">
  <div class="additionalSettings">
    <itl-textarea
      [title]="'Bemerkung hinzufügen'"
      [(ngModel)]="order.annotation"
      [maxlength]="maxAnnotationLength"
      icon="alberta-comment"
      [preventEnter]="true"
    ></itl-textarea>
    <div class="chips-wrapper">
      <itl-chip
        *ngFor="let defaultAnnotation of defaultAnnotations"
        class="chip"
        (chipClicked)="addAnnotation(defaultAnnotation)"
        [showDismiss]="false"
        [showRippleEffect]="true"
        >{{ defaultAnnotation.value }}</itl-chip
      >
    </div>
  </div>
  <!--Delivery Options-->
  <div class="delivery-options">
    <div class="title">Lieferoptionen</div>
    <itl-detail-item>
      <itl-detail-item-icon>
        <ion-icon class="lorry" name="alberta-lorry"></ion-icon>
      </itl-detail-item-icon>
      <span>Gewünschtes Lieferdatum: </span>
      <span class="bold">{{ order.deliveryDate | date: 'dd.MM.yyyy' }}</span>
    </itl-detail-item>
    <itl-detail-item>
      <itl-detail-item-icon>
        <ion-icon class="accounting-month" name="alberta-accounting-month"></ion-icon>
      </itl-detail-item-icon>
      <span>Versorgungsmonate: </span>
      <span class="bold" *ngFor="let month of order.accountingMonth; let i = index">
        <span *ngIf="i > 0">, </span>
        <span>{{ month | number2MonthPipe }}</span>
      </span>
    </itl-detail-item>
    <itl-detail-item>
      <itl-detail-item-icon>
        <ion-icon name="alberta-address"></ion-icon>
      </itl-detail-item-icon>
      <div>Lieferadresse:</div>
      <div class="bold">{{ order.deliveryAddress?.title | titlePipe }} {{ order.deliveryAddress?.name }}</div>
      <div class="bold">{{ order.deliveryAddress?.address }}</div>
      <div class="bold">{{ order.deliveryAddress?.additionalAddress }}</div>
      <div class="bold">{{ order.deliveryAddress?.additionalAddress2 }}</div>
      <div class="bold">{{ order.deliveryAddress?.postalCode }} {{ order.deliveryAddress?.city }}</div>
    </itl-detail-item>
    <itl-detail-item *ngIf="order.deliveryInformation">
      <itl-detail-item-icon>
        <ion-icon name="alberta-document-info"></ion-icon>
      </itl-detail-item-icon>
      <span>Lieferinformationen: </span>
      <span class="bold">{{ order.deliveryInformation }} </span>
      <div *ngIf="order.deliveryStartTime">
        {{ 'order.deliveryStartTime' | translate }}:
        <span class="bold">{{ order.deliveryStartTime }}</span>
      </div>
      <div *ngIf="order.deliveryOption">
        {{ 'order.deliveryOption' | translate }}:
        <span class="bold"> {{ order.deliveryOption }} </span>
      </div>
      <div *ngIf="order.deliveryNote">
        {{ 'order.deliveryNote' | translate }}:
        <span class="bold"> {{ order.deliveryNote }} </span>
      </div>
    </itl-detail-item>
    <itl-detail-item *ngIf="order.tags">
      <itl-detail-item-icon>
        <ion-icon name="alberta-dot"></ion-icon>
      </itl-detail-item-icon>
      <span>{{ 'order.tags' | translate }}: </span>
      <span class="bold">
        <ng-container *ngFor="let tag of order.tags; let last = last">
          {{ tag }}
          <span *ngIf="!last"> , </span>
        </ng-container>
      </span>
    </itl-detail-item>
  </div>
  <!--Articles-->
  <div class="title title-artile">Artikel</div>
  <div class="articles">
    <div class="article" *ngFor="let articleLine of orderedActiveArticleLines">
      <itl-integratedcare-article
        [article]="articleLine.article"
        [labelIsPrivateSale]="articleLine.isPrivateSale"
        [maxAmountExceeded]="
          articleLine.maxAmount && articleLine.maxAmount.currentQuantity > articleLine.maxAmount.maxQuantityBaseOnScope
        "
        [icon]="articleLine.seriesDataId ? 'alberta-series-article' : 'alberta-article'"
        [hasAdditionalCards]="articleLine.active && articleLine.maxAmount"
      >
        <ng-container slot="dosage">
          Menge: {{ articleLine?.quantity }} {{ articleLine?.unit | articleUnitPipe }} ({{
            articleLine?.packagingUnit?.quantity
          }}
          {{ 'order.edit.unit' | translate }})
        </ng-container>
        <ng-container slot="additionalCards">
          <itl-card *ngIf="articleLine.active && articleLine.maxAmount" [header]="'order.edit.maxQuantity' | translate">
            <span
              [style.color]="
                articleLine.maxAmount.currentQuantity > articleLine.maxAmount.maxQuantityBaseOnScope ? '#d44949' : ''
              "
            >
              {{ articleLine.maxAmount.currentQuantity }} {{ 'order.edit.of' | translate }}
              {{ articleLine.maxAmount.maxQuantityBaseOnScope }}
            </span>
          </itl-card>
        </ng-container>
      </itl-integratedcare-article>
    </div>
  </div>
  <itl-warning-item *ngIf="!orderedActiveArticleLines || (orderedActiveArticleLines.length === 0 && !isLoading)">
    Du hast noch keine Artikel ausgewählt
  </itl-warning-item>
</div>
